import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { exportaExcelConFotoOpcional } from "../../../excelConFotos";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoDisponible() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [articulos, setArticulos] = useState([]);

  const [modalDesgloceDisp, setModalDesgloceDisp] = useState(false);
  const toggleDesgloceDisp = () => setModalDesgloceDisp(!modalDesgloceDisp);
  const [dispRows, setDispRows] = useState([]);
  const [dispCodigo, setDispCodigo] = useState("");
  const [dispNombre, setDispNombre] = useState("");

  function verDesgloceDisponible(idArticulo, codigo, nombre) {
    setDispRows([]);
    setDispCodigo(codigo);
    setDispNombre(nombre);
    axios
      .get(`${process.env.REACT_APP_URL_INVENTARIOS}DisponibleDetalle/${idArticulo}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        setDispRows(res.data || []);
        setModalDesgloceDisp(true);
      })
      .catch((err) => console.log(err));
  }
  // Filtro de articulo multiple: lista de ids; vacia = todos
  const [selectedArticulos, setSelectedArticulos] = useState([]);
  const pasaArticulo = (id) => selectedArticulos.length === 0 || selectedArticulos.includes(String(id));
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [lineas, setLineas] = useState([]);
  const [selectedLinea, setSelectedLinea] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);
  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  // Totales del pie: sobre TODOS los renglones filtrados, no solo la pagina visible
  const [totales, setTotales] = useState({ inventario: 0, pedido: 0, traspaso: 0, apartado: 0, disponible: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 100;

  useMemo(() => {
    axios
      .get(`${URL_INVENTARIOS}Disponible`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        let array = allDisponible.map((a)=>{
          if(a.inventario != 0 || a.pedido !=0 || a.disponible !=0){
          return a
          }
        }).filter(function (el) {
          return el != null;
        })
        setComments(array);

        let unicosArt = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulos(unicosArt);

        let unicosMar = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idMarca === value.idMarca)
        );
        setMarcas(unicosMar);

        let unicosFam = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idFamilia === value.idFamilia)
        );
        setFamilias(unicosFam);

        let unicosLinea = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idLinea === value.idLinea)
        );
        setLineas(unicosLinea);
      })
      .catch((err) => {
        console.log(err);
      });


  }, []);


  function PDFTabla() {
    let total_inventario = 0;
    let total_pedido = 0;
    let total_traspaso = 0;
    let total_disponible = 0;

    const data = comments
      .filter(
        (comment) =>
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.inventario ?? "").toString().includes(search) ||
          String(comment.pedido ?? "").toString().includes(search) ||
          String(comment.traspaso ?? "").toString().includes(search) ||
          String(comment.disponible ?? "").toString().includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          total_inventario =
            parseFloat(total_inventario) + parseFloat(a.inventario);
          total_pedido = parseFloat(total_pedido) + parseFloat(a.pedido);
          total_traspaso = parseFloat(total_traspaso) + parseFloat(a.traspaso);
          total_disponible =
            parseFloat(total_disponible) + parseFloat(a.disponible);
          return [
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.inventario),
            new Intl.NumberFormat("en-US").format(a.pedido),
            new Intl.NumberFormat("en-US").format(a.traspaso),
            new Intl.NumberFormat("en-US").format(a.disponible),
          ]
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Disponible`, 20, 40);
    doc.autoTable({
      head: [[ "Nombre", "Inventario", "Pedido", "Traspaso", "Disponible"]],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "Total",
          new Intl.NumberFormat("en-US").format(total_inventario),
          new Intl.NumberFormat("en-US").format(total_pedido),
          new Intl.NumberFormat("en-US").format(total_traspaso),
          new Intl.NumberFormat("en-US").format(total_disponible),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`Disponible.pdf`);
  }

  // Excel GENERAL por talla y color: todos los articulos, sin filtros ni busqueda
  async function excelGeneralTallaColor() {
    let detalle = [];
    try {
      const r = await axios.get(`${URL_INVENTARIOS}DisponibleDetalleTodos`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      detalle = r.data || [];
    } catch (err) {
      console.log(err);
      return;
    }
    const filas = detalle.map((d) => ({
      _idArticulo: d.idArticulo, _idColor: d.idColor,
      Modelo: `${d.codigo} ${d.nombre}`.trim(), Departamento: d.familia, Linea: d.linea,
      Color: d.color, Talla: d.talla,
      Inventario: d.inventario, PorRecibir: d.porRecibir, Pedido: d.pedido, Traspaso: d.traspaso, Apartado: d.apartado || 0, Disponible: d.disponible,
    }));
    const cols = ["Modelo", "Departamento", "Linea", "Color", "Talla", "Inventario", "PorRecibir", "Pedido", "Traspaso", "Apartado", "Disponible"];
    exportaExcelConFotoOpcional({ filas, columnas: cols, nombreArchivo: "DisponibleGeneralPorTallaColor", hoja: "General" });
  }

  async function excel() {
    // Desglose por talla y color de TODOS los articulos; se acota a los que
    // pasan los filtros de la tabla (mismos ids que la hoja general).
    let detalle = [];
    try {
      const r = await axios.get(`${URL_INVENTARIOS}DisponibleDetalleTodos`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      detalle = r.data || [];
    } catch (err) {
      console.log(err);
    }
    const dataExcel = comments
      .filter(
        (comment) =>
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.inventario ?? "").toString().includes(search) ||
          String(comment.pedido ?? "").toString().includes(search) ||
          String(comment.traspaso ?? "").toString().includes(search) ||
          String(comment.disponible ?? "").toString().includes(search)
      )
      .map((a) => {

        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          return {
            idArticulo: a.idArticulo,
            Nombre: a.nombre,
            Departamento: a.familia,
            Linea: a.linea,
            Inventario: a.inventario,
            Pedido: a.pedido,
            Traspaso: a.traspaso,
            Apartado: a.apartado || 0,
            Disponible: a.disponible,
          }
        }
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    const idsVisibles = new Set(dataExcelLimpia.map((a) => String(a.idArticulo)));
    const porTallaColor = detalle
      .filter((d) => idsVisibles.has(String(d.idArticulo)))
      .map((d) => ({
        _idArticulo: d.idArticulo, _idColor: d.idColor,
        Modelo: `${d.codigo} ${d.nombre}`.trim(), Departamento: d.familia, Linea: d.linea,
        Color: d.color, Talla: d.talla,
        Inventario: d.inventario, PorRecibir: d.porRecibir, Pedido: d.pedido, Traspaso: d.traspaso, Apartado: d.apartado || 0, Disponible: d.disponible,
      }));
    const colsTC = ["Modelo", "Departamento", "Linea", "Color", "Talla", "Inventario", "PorRecibir", "Pedido", "Traspaso", "Apartado", "Disponible"];
    const colsModelo = ["Nombre", "Inventario", "Departamento", "Linea", "Pedido", "Traspaso", "Apartado", "Disponible"];

    exportaExcelConFotoOpcional({
      nombreArchivo: "ListadoDisponible",
      hojas: [
        { nombre: "PorModelo", filas: dataExcelLimpia.map(({ idArticulo, ...resto }) => ({ _idArticulo: idArticulo, ...resto })), columnas: colsModelo },
        { nombre: "PorTallaColor", filas: porTallaColor, columnas: colsTC },
      ],
    });
  }

  function enviaMail() {
    let total_inventario = 0;
    let total_pedido = 0;
    let total_traspaso = 0;
    let total_disponible = 0;

    const data = comments
      .filter(
        (comment) =>
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.inventario ?? "").toString().includes(search) ||
          String(comment.pedido ?? "").toString().includes(search) ||
          String(comment.traspaso ?? "").toString().includes(search) ||
          String(comment.disponible ?? "").toString().includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {

        if (
          pasaArticulo(a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          total_inventario = total_inventario + a.inventario;
          total_pedido = total_pedido + a.pedido;
          total_traspaso = total_traspaso + a.traspaso;
          total_disponible = total_disponible + a.disponible;
          return [
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.inventario),
            new Intl.NumberFormat("en-US").format(a.pedido),
            new Intl.NumberFormat("en-US").format(a.traspaso),
            new Intl.NumberFormat("en-US").format(a.disponible),
          ]
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Disponible`, 20, 40);
    doc.autoTable({
      head: [[ "Nombre", "Inventario", "Pedido", "Traspso", "Disponible"]],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "Total",
          new Intl.NumberFormat("en-US").format(total_inventario),
          new Intl.NumberFormat("en-US").format(total_pedido),
          new Intl.NumberFormat("en-US").format(total_traspaso),
          new Intl.NumberFormat("en-US").format(total_disponible),
        ],
      ],
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Disponible",
          email: mailTo,
          fileName: "ListadoDisponible.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Departamento", field: "familia", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "Inventario", field: "inventario", sortable: true },
    { name: "Pendiente Recibir", field: "porRecibir", sortable: true },
    { name: "Pendiente Surtir", field: "pedido", sortable: true },
    { name: "Pendiente Traspaso", field: "traspaso", sortable: true },
    { name: "Apartado", field: "apartado", sortable: true },
    { name: "Disponible", field: "disponible", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.inventario ?? "").toString().includes(search) ||
          String(comment.pedido ?? "").toString().includes(search) ||
          String(comment.traspaso ?? "").toString().includes(search) ||
          String(comment.disponible ?? "").toString().includes(search)
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        String(e.activo ?? "").includes(activo)
      );
    }

    if (selectedArticulos.length) {
      computedComments = computedComments.filter((e) => pasaArticulo(e.idArticulo));
    }

    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        String(e.idMarca ?? "").includes(selectedMarca)
      );
    }

    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        String(e.idLinea ?? "").includes(selectedLinea)
      );
    }

    if (selectedFamilia) {
      computedComments = computedComments.filter((e) =>
        String(e.idFamilia ?? "").includes(selectedFamilia)
      );
    }

    setTotalItems(computedComments.length);
    setTotales(computedComments.reduce((t, a) => ({
      inventario: t.inventario + (Number(a.inventario) || 0),
      pedido: t.pedido + (Number(a.pedido) || 0),
      traspaso: t.traspaso + (Number(a.traspaso) || 0),
      apartado: t.apartado + (Number(a.apartado) || 0),
      disponible: t.disponible + (Number(a.disponible) || 0),
    }), { inventario: 0, pedido: 0, traspaso: 0, apartado: 0, disponible: 0 }));

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "inventario" &&
      sorting.field != "porRecibir" &&
      sorting.field != "pedido" &&
      sorting.field != "traspaso" &&
      sorting.field != "disponible"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "inventario" ||
        sorting.field == "porRecibir" ||
        sorting.field == "pedido" ||
        sorting.field == "traspaso" ||
        sorting.field == "disponible")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "inventario" ||
      sorting.field == "porRecibir" ||
        sorting.field == "pedido" ||
        sorting.field == "traspaso" ||
        sorting.field == "disponible")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedArticulos, activo, selectedFamilia, selectedLinea, selectedMarca]);

  function jalaFoto(idEdit) {
    setPhoto("");
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));

    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  const totalDisponible = totales.disponible;
  const totalPedido = totales.pedido;
  const totalTraspaso = totales.traspaso;
  const totalInventario = totales.inventario;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_disponible ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={excelGeneralTallaColor}
                  title="Todos los modelos por color y talla, sin filtros"
                >
                  Excel general <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Disponible</h3>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Autocomplete
                  multiple
                  size="small"
                  disableCloseOnSelect
                  options={articulos.slice().sort((a, b) => (a.nombre > b.nombre ? 1 : -1))}
                  getOptionLabel={(o) => o.nombre || ""}
                  getOptionSelected={(o, v) => String(o.idArticulo) === String(v.idArticulo)}
                  value={articulos.filter((a) => selectedArticulos.includes(String(a.idArticulo)))}
                  onChange={(e, vals) => {
                    setSelectedArticulos(vals.map((v) => String(v.idArticulo)));
                    setCurrentPage(1);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder={selectedArticulos.length ? "" : "Todos los modelos"} />
                  )}
                  style={{ minWidth: 220 }}
                />
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.marca > b.marca ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idMarca}>{a.marca}</option>;
                    })}
                </Input>
              </td> <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamilia}
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.familia > b.familia ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idFamilia}>{a.familia}</option>;
                    })}
                </Input>
              </td> <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.linea > b.linea ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idLinea}>{a.linea}</option>;
                    })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.nombre}</td>
                      <td>{a.marca}</td>
                      <td>{a.familia}</td>
                      <td>{a.linea}</td>
                      <td> {new Intl.NumberFormat("en-US").format(a.inventario)} </td>
                      <td>{new Intl.NumberFormat("en-US").format(a.porRecibir)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.pedido)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.traspaso)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.apartado || 0)}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.disponible)}
                      </td>
                      <td>
                        <Button
                          color="primary"
                          size="sm"
                          title="Desglose por color y talla"
                          onClick={(e) => verDesgloceDisponible(a.idArticulo, a.codigo, a.nombre)}
                        >
                          <i class="fas fa-th"></i>
                        </Button>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFoto(a.idArticulo)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalInventario)}
                </td>
                <td></td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalPedido)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTraspaso)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.apartado)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalDisponible)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>Ficha Tecnica</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/cavannaImportacionArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : (
              <h4>No se ha subido una Ficha Tecnica....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

        <Modal size="xl" isOpen={modalDesgloceDisp} toggle={toggleDesgloceDisp}>
          <ModalHeader toggle={toggleDesgloceDisp}>
            <h4>Disponible por Color y Talla</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={5}><Label>Codigo: {dispCodigo}</Label></Col>
              <Col md={7}><Label>Nombre: {dispNombre}</Label></Col>
            </Row>
            <br />
            {dispRows.length === 0 ? (
              <h6>Sin movimientos para este articulo.</h6>
            ) : (
              (() => {
                const colores = [...new Set(dispRows.map((r) => r.color))].sort((a, b) => a.localeCompare(b));
                const tallas = [...new Set(dispRows.map((r) => r.talla))].sort((a, b) => a.localeCompare(b));
                const val = (c, t) =>
                  dispRows
                    .filter((r) => r.color === c && r.talla === t)
                    .reduce((s, r) => s + Number(r.disponible || 0), 0);
                const totalGeneral = dispRows.reduce((s, r) => s + Number(r.disponible || 0), 0);
                return (
                  <>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <Table size="sm" striped bordered style={{ minWidth: `${(tallas.length + 2) * 90}px`, whiteSpace: "nowrap", marginBottom: 0 }}>
                        <thead>
                          <tr>
                            <th style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 2, minWidth: "150px" }}>Color</th>
                            {tallas.map((t) => (
                              <th key={t} style={{ minWidth: "90px", textAlign: "center" }}>{t}</th>
                            ))}
                            <th style={{ minWidth: "100px", textAlign: "center" }}>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {colores.map((c) => {
                            const totalFila = tallas.reduce((s, t) => s + val(c, t), 0);
                            return (
                              <tr key={c}>
                                <td style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 1, fontWeight: 600 }}>{c}</td>
                                {tallas.map((t) => {
                                  const q = val(c, t);
                                  return (
                                    <td key={t} style={{ textAlign: "center", color: q < 0 ? "#dc2626" : q ? "inherit" : "#cbd5e1" }}>
                                      {q ? new Intl.NumberFormat("en-US").format(q) : "-"}
                                    </td>
                                  );
                                })}
                                <td style={{ textAlign: "center", fontWeight: 700 }}>
                                  {new Intl.NumberFormat("en-US").format(totalFila)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td style={{ position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 1, fontWeight: 700 }}>Total</td>
                            {tallas.map((t) => (
                              <td key={t} style={{ textAlign: "center", fontWeight: 700 }}>
                                {new Intl.NumberFormat("en-US").format(colores.reduce((s, c) => s + val(c, t), 0))}
                              </td>
                            ))}
                            <td style={{ textAlign: "center", fontWeight: 700 }}>
                              {new Intl.NumberFormat("en-US").format(totalGeneral)}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <br />
                    <h6>Detalle</h6>
                    <div style={{ width: "100%", overflowX: "auto" }}>
                      <Table size="sm" striped bordered style={{ whiteSpace: "nowrap" }}>
                        <thead>
                          <tr>
                            <th>Color</th><th>Talla</th>
                            <th style={{ textAlign: "center" }}>Inventario</th>
                            <th style={{ textAlign: "center" }}>Pend. Recibir</th>
                            <th style={{ textAlign: "center" }}>Pend. Surtir</th>
                            <th style={{ textAlign: "center" }}>Pend. Traspaso</th>
                            <th style={{ textAlign: "center" }}>Disponible</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dispRows
                            .slice()
                            .sort((a, b) => (a.color + a.talla).localeCompare(b.color + b.talla))
                            .map((r, i) => (
                              <tr key={i}>
                                <td>{r.color}</td>
                                <td>{r.talla}</td>
                                <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US").format(r.inventario)}</td>
                                <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US").format(r.porRecibir)}</td>
                                <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US").format(r.pedido)}</td>
                                <td style={{ textAlign: "center" }}>{new Intl.NumberFormat("en-US").format(r.traspaso)}</td>
                                <td style={{ textAlign: "center", fontWeight: 700 }}>{new Intl.NumberFormat("en-US").format(r.disponible)}</td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </>
                );
              })()
            )}
          </ModalBody>
        </Modal>


      {loader}
    </>
  );
}

export default ListadoDisponible;
